import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-locker-billet',
  template: `
    <div class="description">
      {{ text }}
    </div>
    <button small app-fill-green-button (click)="redirectTo()">Повысить тариф</button>
  `,
  styleUrls: ['./locker-billet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LockerBilletComponent implements OnInit {
  @Input() text: string = 'Загрузка файлов доступна на платных тарифах';
  constructor(private _router: Router) {}

  ngOnInit(): void {}

  redirectTo() {
    this._router.navigateByUrl(`private-office/tariffs-and-payment`);
  }
}
